<template>
  <section
    class="bg-white border border-gray-200 shadow-sm my-4 p-4 md:rounded-xl"
  >
    <slot></slot>
  </section>
</template>
